const PATH_PREFIX = '/admin';

export default PATH_PREFIX;
